import * as yup from 'yup';
import { enrich } from './yupEnrichment';
enrich(yup.object);
export const defaultProperties = yup.object({
    isHidden: yup
        .boolean()
        .meta({ description: 'sets visibility:hidden to the component style node' })
        .notRequired(),
    isCollapsed: yup
        .boolean()
        .meta({ description: 'sets isCollapsed for component' })
        .notRequired(),
});
export const createDataRef = (schemas) => yup.string().meta({ schemas });
export const createWeakDataRef = (schemaType) => yup.string().meta({ schemaType, weakRef: true });
const createSchema = (type, schema) => {
    const baseSchema = yup.object({
        id: yup.string().required(),
        type: yup.mixed().oneOf([type]).default(type),
    });
    return schema.concat(baseSchema);
};
export { createSchema as createDataSchema };
export const createPropertiesSchema = (type, schema) => createSchema(type, schema).concat(defaultProperties);
//# sourceMappingURL=schemaUtils.js.map